var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.707 0l-3-3a.5.5 0 0 1 .707-.708L7 10.293l5.646-5.647a.5.5 0 0 1 .707 0",
    clipRule: "evenodd"
  })));
};
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "f499e479f4064f03de76559af0e2eaa4.svg";